<div class="position-relative">
    <div class="p-md-9 p-4 box-popup d-flex flex-column">
        <!-- Voivodeshoip -->
        @if (form.controls.voivodeship.invalid) {
            <div class="fs-14 mb-5 ls-1 fw-700 text-uppercase font-secondary text-center">
                {{ 'CONFIGURATOR.POPUP.select-voivodeship' | translate }}
            </div>
            @if (form.controls.voivodeship.invalid) {
                <div class="list">
                    @if (voivodeships$ | async; as voivodeships) {
                        <div class="row gy-3 gx-3">
                            @for (voivodeship of voivodeships; track voivodeship) {
                                <div class="col-12 col-md-6">
                                    <div
                                        class="btn btn-outline btn-secondary pointer w-100"
                                        role="button"
                                        tabindex="0"
                                        (click)="onClickVoivodeship($event, voivodeship.code)"
                                        (keyup.enter)="onClickVoivodeship($event, voivodeship.code)"
                                    >
                                        {{ voivodeship.name }}
                                    </div>
                                </div>
                            }
                        </div>
                    } @else {
                        <div class="spinner mx-auto"></div>
                    }
                </div>
            }
        }

        <!-- Partner -->
        @if (form.controls.voivodeship.valid && form.controls.partner.invalid) {
            <div class="fs-14 mb-5 ls-1 fw-700 text-uppercase font-secondary text-center">
                {{ 'CONFIGURATOR.POPUP.select-partner' | translate }}
            </div>
            <div class="list">
                <div>
                    @if (partners$ | async; as partners) {
                        <div class="row gy-3 gx-3">
                            @for (partner of partners; track partner) {
                                <div class="col-12 col-md-6">
                                    <div
                                        (click)="onClickPartner($event, partner)"
                                        (keyup.enter)="onClickPartner($event, partner)"
                                        role="button"
                                        tabindex="0"
                                        class="btn btn-outline btn-secondary d-block text fw-700 pointer w-100 text-wrap h-100"
                                    >
                                        <div class="mb-2 text-primary">{{ partner.name }}</div>
                                        <div class="text-gray-300">
                                            {{ partner.address.street }} {{ partner.address.houseNumber
                                            }}{{ partner.address.flatNumber ? '/' + partner.address.flatNumber : '' }}
                                        </div>
                                        <div class="text-gray-300">{{ partner.address.city }}</div>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
            <div class="pt-4">
                <a class="text-gray-300 pointer" href="#" (click)="onPartnersBackClick($event)">{{ 'BUTTONS.back' | translate }}</a>
            </div>
        }

        <!-- PDF -->
        @if (form.controls.voivodeship.valid && form.controls.partner.valid) {
            <div class="fs-14 mb-5 ls-1 fw-700 text-uppercase font-secondary text-center">
                {{ 'CONFIGURATOR.POPUP.download-pdf' | translate }}
            </div>
            <div class="list">
                <div class="row gx-0 mb-5">
                    <div class="col-md-7 col-12">
                        <h5 class="font-secondary text-secondary">{{ 'CONFIGURATOR.POPUP.snapshotId' | translate }}</h5>
                        <p class="text-primary fw-700 mb-5">{{ data.id }}</p>
                        <h5 class="font-secondary text-secondary">{{ 'CONFIGURATOR.POPUP.partner' | translate }}</h5>
                        <p>{{ selectedPartner?.name }}</p>
                        <p>
                            {{ selectedPartner?.address?.street }} {{ selectedPartner?.address?.houseNumber
                            }}{{ selectedPartner?.address?.flatNumber ? '/' + selectedPartner?.address?.flatNumber : '' }}<br />
                            {{ selectedPartner?.address?.city }}<br />
                            {{ selectedPartner?.email }}<br />
                            {{ selectedPartner?.phone }}
                        </p>
                    </div>
                    <div class="col-md-5 col-12">
                        <img class="w-75 d-block mx-auto" [src]="metrixUrl + 'api/proxy/snapshots/' + data.id + '/image'" alt="" />
                    </div>
                    <div class="d-flex align-items-center">
                        <div>
                            <input [formControl]="phoneFormControl" type="text" placeholder="{{ 'CONFIGURATOR.POPUP.FROM.phone' | translate }}" />
                        </div>
                        <span translate class="ms-6">CONFIGURATOR.POPUP.FROM.phone.description</span>
                    </div>
                    @if (form.get('phone')?.touched && form.get('phone')?.errors) {
                        <div class="fs-12 pt-2 text-danger" translate>CONTACT.form_messages.phoneNumber</div>
                    }
                    <div class="d-flex align-items-center">
                        <label class="d-flex align-items-center mt-5 input-container">
                            <input type="checkbox" class="me-3" data-md-icheck (change)="toggleButtonAccess($event)" />
                            <span class="checkmark"></span
                        ></label>
                        <div class="mt-5 ps-3">
                            {{ 'CONFIGURATOR.POPUP.regulations_acceptance_p1' | translate }}
                            <a [routerLink]="['/legal', 'regulations'] | localize" target="_blank"> {{ 'CONFIGURATOR.POPUP.regulation' | translate }}</a>
                            {{ 'CONFIGURATOR.POPUP.regulations_acceptance_p2' | translate }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="text-center d-flex flex-column justify-content-between align-items-center">
                <button
                    class="btn btn-outline btn-primary"
                    [disabled]="this.form.invalid || isButtonDisabled"
                    [ngClass]="{
                        pointer: !this.form.invalid || !isButtonDisabled,
                        disabled: this.form.invalid || isButtonDisabled,
                    }"
                    (click)="onPDFDownloadClick($event)"
                >
                    {{ 'BUTTONS.download-pdf' | translate }}
                </button>
            </div>
        }

        @if ((saving$ | async) === true) {
            <div class="position-absolute loader d-flex align-items-center">
                <div class="spinner mx-auto"></div>
            </div>
        }

        <div class="popup-close-btn" role="button" tabindex="0" (click)="closeClick()" (keyup.enter)="closeClick()"></div>
    </div>
</div>
